const KEYBOARD_KEYS = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
  COMMA: ',',
};

const KEYBOARD_EVENTS = {
  KEY_DOWN: 'keydown',
  KEY_UP: 'keyup',
};

export { KEYBOARD_KEYS, KEYBOARD_EVENTS };
